export default "__VITE_ASSET____TvSKdQ__"